/* table */
import { CellContext } from '@tanstack/react-table';

/* yarn */
import { startOfDay, subDays } from 'date-fns';

/* React */
import React from 'react';

/* internal */
import { IconCell, IconCellType } from './IconCell';

export const IconDateOver30daysCell = <TData,>({
    cell,
    iconCellProps
}: CellContext<TData, string | number | Date | null> & {
    iconCellProps: IconCellType;
}): JSX.Element | null => {
    const rowDateValue = cell.getValue();

    if (!rowDateValue) {
        return null;
    }

    const rowDate = new Date(rowDateValue as string);

    const comparisonDate = subDays(new Date(), 30);

    // Set both dates to the start of their respective days
    const rowStartOfDay = startOfDay(rowDate);
    const comparisonStartOfDay = startOfDay(comparisonDate);

    const isOver30days =
        rowStartOfDay.getTime() < comparisonStartOfDay.getTime();

    return <IconCell condition={isOver30days} iconCellProps={iconCellProps} />;
};
